import { render, staticRenderFns } from "./ListInvoicePage.vue?vue&type=template&id=72cd4e48&"
import script from "./ListInvoicePage.vue?vue&type=script&lang=js&"
export * from "./ListInvoicePage.vue?vue&type=script&lang=js&"
import style0 from "./ListInvoicePage.vue?vue&type=style&index=0&id=72cd4e48&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports